import { render } from "./TelephoneInput.vue?vue&type=template&id=56149f70&scoped=true"
import script from "./TelephoneInput.vue?vue&type=script&lang=js"
export * from "./TelephoneInput.vue?vue&type=script&lang=js"

import "./TelephoneInput.vue?vue&type=style&index=0&id=56149f70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56149f70"

export default script